import { Authentication, PluginConfig } from '@gc-bridge/models';
import { ShellConfig as BaseShellConfig, RemoteConfig } from '@gcportal/base';

interface ExtendedRemoteConfig extends RemoteConfig {
  plugins?: PluginConfig[];
}

export interface ShellConfig extends BaseShellConfig {
  /**
   * Authentication configuration containing Okta issuer and clientId
   * and persona suffix.
   */
  authentication: Authentication;

  /**
   * Configuration TTL in seconds.
   */
  configTtlSeconds?: number;
  
  remotes: ExtendedRemoteConfig[];

  /**
   * Maps region codes to their display names.
   * Used to dynamically render region selection in the ChooseRegionDialog
   * for remotes that have region-based redirect URLs.
   *
   * @example
   * {
   *   "na": "North America",
   *   "emea": "Europe, Middle East, and Africa",
   *   "apac": "Asia-Pacific"
   * }
   */
  regions?: Record<string, string>;
}
